var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sysAdmin)?_c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttonsConfig,"routeKey":_vm.routeKey}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2ddc99a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationSpeedDial.vue
// module id = null
// module chunks = 